import { AppRoutes } from "@/Routers/AppRouter";
import AppointmentDetail from "@/pages/Appointments/AppointmentDetail";
import AppointmentPrint from "@/pages/Appointments/AppointmentPrint";
import AppointmentsPage from "@/pages/Appointments/AppointmentsPage";
import { PrintAppointments } from "@/pages/Appointments/components/PrintAppointments";
import { ManageQueuePage } from "@/pages/Facility/queues/ManageQueue";
import QueuesIndex from "@/pages/Facility/queues/QueuesIndex";
import TokenEncounterRedirect from "@/pages/Facility/queues/TokenEncounterRedirect";
import { SchedulableResourceType } from "@/types/scheduling/schedule";
import { Redirect } from "raviger";

const ScheduleRoutes: AppRoutes = {
  "/facility/:facilityId/appointments": () => (
    <AppointmentsPage resourceType={SchedulableResourceType.Practitioner} />
  ),
  "/facility/:facilityId/appointments/print": ({ facilityId }) => (
    <PrintAppointments
      facilityId={facilityId}
      resourceType={SchedulableResourceType.Practitioner}
    />
  ),
  "/facility/:facilityId/patient/:patientId/appointments/:appointmentId": ({
    appointmentId,
  }) => <AppointmentDetail appointmentId={appointmentId} />,
  "/facility/:facilityId/patient/:patientId/appointments/:appointmentId/print":
    ({ appointmentId }) => <AppointmentPrint appointmentId={appointmentId} />,

  "/facility/:facilityId/queues": ({ facilityId }) => (
    <QueuesIndex
      facilityId={facilityId}
      resourceType={SchedulableResourceType.Practitioner}
    />
  ),

  "/facility/:facilityId/practitioner/:practitionerId/queues/:queueId": ({
    facilityId,
    practitionerId,
    queueId,
  }) => (
    <Redirect
      to={`/facility/${facilityId}/practitioner/${practitionerId}/queues/${queueId}/ongoing`}
    />
  ),
  "/facility/:facilityId/queue/:queueId/token/:tokenId": ({
    facilityId,
    queueId,
    tokenId,
  }) => (
    <TokenEncounterRedirect
      facilityId={facilityId}
      tokenId={tokenId}
      queueId={queueId}
    />
  ),

  "/facility/:facilityId/practitioner/:practitionerId/queues/:queueId/ongoing":
    ({ facilityId, practitionerId, queueId }) => (
      <ManageQueuePage
        facilityId={facilityId}
        resourceType={SchedulableResourceType.Practitioner}
        resourceId={practitionerId}
        queueId={queueId}
        tab="ongoing"
      />
    ),
  "/facility/:facilityId/practitioner/:practitionerId/queues/:queueId/completed":
    ({ facilityId, practitionerId, queueId }) => (
      <ManageQueuePage
        facilityId={facilityId}
        resourceType={SchedulableResourceType.Practitioner}
        resourceId={practitionerId}
        queueId={queueId}
        tab="completed"
      />
    ),
};

export default ScheduleRoutes;
